<form
  name="form"
  ng-submit="$close()"
>
  <div class="modal-header">
    <button type="button" class="close" ng-click="$dismiss()">&times;</button>
    <h4 class="modal-title">
      Duplicar cronograma
    </h4>
  </div>
  <div class="modal-body">
    <p>Selecione para quais talhões deseja duplicar o cronograma:</p>
    <ui-select
      ng-model="$ctrl.duplicationTargets"
      multiple
      name="glebas"
      required
      append-to-body="true"
    >
      <ui-select-match placeholder="Glebas">{{$item.descricao | capitalize}}</ui-select-match>
      <ui-select-choices
        repeat="gleba in $ctrl.glebasAvailableForDuplication() track by gleba.id"
      >
        <span ng-bind-html="gleba.descricao | highlight: $select.search"></span>
      </ui-select-choices>
    </ui-select>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-link" ng-click="$dismiss()">Cancelar</button>
    <button
      type="submit"
      class="btn btn-primary"
      ng-disabled="form.$invalid"
    >
      Duplicar
    </button>
  </div>
</form>
